import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import AdaptiveHomepage from "pages/adaptive-homepage";
import ContactSupport from "pages/contact-support";
import AboutDreamCodersClub from "pages/about-dream-coders-club";
import InstitutionalSolutionsHub from "pages/institutional-solutions-hub";
import IndividualLearningPortal from "pages/individual-learning-portal";
import IndividualLearningNew from "pages/IndividualLearningNew"; // Ensure this is the correct path
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<AdaptiveHomepage />} />
        <Route path="/adaptive-homepage" element={<AdaptiveHomepage />} />
        <Route path="/contact-support" element={<ContactSupport />} />
        <Route path="/about-dream-coders-club" element={<AboutDreamCodersClub />} />
        <Route path="/institutional-solutions-hub" element={<InstitutionalSolutionsHub />} />
        <Route path="/individual-learning-portal" element={<IndividualLearningPortal />} />
        <Route path="/individual-learning-new" element={<IndividualLearningNew />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;